import { getToken } from '../api/apiHelper'
import { getAccounts } from './accounts'
import { getCompany } from './company'
import { getConfigs } from './config'
import { getAddressTypes } from './eInvoice'
import { getExternalAccounts } from './externalAccounts'
import { actionCreatorAsync } from './index'
import { getTranslations } from './language'
import { loadPayNowAuthorizationStatus } from './payNowManagement'
import { getSettings } from './settings'
import { getSubscription, getSubscriptionSettings, updateAccountingSubscription } from './subscriptionManagement'
import { updateToken } from './token'
import { getUser } from './user'

export const loadAppVitals = () => {
  return async (dispatch, getState) => {
    const zToken = getToken() || ''
    dispatch(updateToken(zToken))
    await dispatch(
      actionCreatorAsync('LOAD_APP_VITALS', async () => {
        const prepareUser = async () => dispatch(getUser())
        const prepareSettings = async () => dispatch(getSettings())
        const prepareCompany = async () => dispatch(getCompany())
        const prepareConfigs = async () => dispatch(getConfigs())
        const prepareAccounts = async () => dispatch(getAccounts())
        const preparePayNow = async () => dispatch(loadPayNowAuthorizationStatus())
        const prepareSubscription = async () => dispatch(getSubscription())
        const prepareAccountingSubscription = async () => dispatch(updateAccountingSubscription())
        const prepareSubscriptionSettings = async () => dispatch(getSubscriptionSettings())
        const prepareAddressTypes = async () => dispatch(getAddressTypes())

        await Promise.all([
          prepareCompany(),
          prepareSettings(),
          prepareConfigs(),
          prepareAccounts(),
          prepareUser(),
          preparePayNow(),
          prepareSubscription(),
          prepareAccountingSubscription(),
          prepareAddressTypes(),
          prepareSubscriptionSettings(),
        ])

        const prepareExternalAccounts = async () => {
          // this needs to wait until the company data is loaded
          const isAgerasNextMigration = getState()?.company?.agerasNextMigration
          return isAgerasNextMigration ? dispatch(getExternalAccounts()) : []
        }

        await prepareExternalAccounts()

        return await dispatch(getTranslations(null))
      }),
    )
  }
}
